// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1InvoicesCreateSchema = z.object({
  invoice: z.object({
    name: z.coerce.string().describe("Invoice name").nullish(),
    description: z.coerce.string().describe("Invoice description").nullish(),
    from: z.string().date().describe("Start date for invoice period").nullish(),
    to: z.string().date().describe("End date for invoice period").nullish(),
    date: z.string().date().describe("Invoice date").nullish(),
    paid: z.optional(z.boolean().describe("Whether the invoice has been paid")),
    invoice_by: z.coerce.string().describe("Invoice grouping method").nullish(),
    list_item_grouping: z.coerce.string().describe("Line item grouping method").nullish(),
    filters: z.optional(z.object({
      project_ids: z.optional(z.array(z.number().int()).describe("Filter by project IDs")),
      client_ids: z.optional(z.array(z.number().int()).describe("Filter by client IDs")),
    }).describe("Invoice filters")),
  }),
});
